import React from "react";
import { FormattedMessage } from "react-intl";

export const MenuType = {
  Header: 1,
  Footer: 2,
};

const EmptyStateMessage = (isFooter) => {
  if (isFooter) {
    return (
      <FormattedMessage
        id="bVo3Wg"
        defaultMessage="Add elements to your menu"
      />
    );
  }

  return (
    <FormattedMessage id="bVo3Wg" defaultMessage="Add elements to your menu" />
  );
};

export const getMenuEmptyState = (isFooter) => [
  {
    id: "empty-state-item",
    parent_id: null,
    type_id: 5,
    name: EmptyStateMessage(isFooter),
  },
];

export function getMenuItems(props) {
  const isFooter = !!props?.onlyTopLevel;

  if (isFooter) {
    const items = props?.menuItems?.value?.filter(
      (i) => i.menu_id === MenuType.Footer
    );
    if (items?.length) return items;
    return getMenuEmptyState(isFooter);
  }

  // if header
  const items = props?.menuItems?.value?.filter(
    (i) => i.menu_id === MenuType.Header
  );
  if (items?.length) return items;
  return getMenuEmptyState(isFooter);
}
